import React, { useContext, useMemo } from 'react';

import styled from '@emotion/styled';

import useListVehicle from '../../../../hooks/dashboard/driver-list/useListVehicle';
import {
  ListVehicleDataType,
  ListVehicleInitialValues,
  ListVehicleSchema,
} from '../../../../models/dashboard/driver-list/list-vehicle';
import { useAppSelector } from '../../../../redux/store';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import CustomSelectField from '../../../FormCom/CustomSelectField';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TextInputField } from '../../../FormCom/FormField';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface ListVehicleModalProps {
  setRefreshData?: React.Dispatch<React.SetStateAction<number>>;
}

const ListVehicleModal: React.FC<ListVehicleModalProps> = ({
  setRefreshData,
}) => {
  const modalContext = useContext(ModalContext);
  const { listVehicle, loading } = useListVehicle();
  const { vehicleCategoryData } = useAppSelector(
    (state) => state.vehicleCategoryData,
  );

  const fleetCategories = useMemo<Record<string, string>>(
    () =>
      (vehicleCategoryData ?? []).reduce<Record<string, string>>(
        (acc, category) => {
          acc[category.displayName] = category.name;
          return acc;
        },
        {},
      ),
    [vehicleCategoryData],
  );

  const onSubmit = (values: ListVehicleDataType, actions: any) => {
    listVehicle(
      {
        ...values,
        vehicleCategory: fleetCategories[values?.vehicleCategory ?? ''],
      },
      () => {
        actions.resetForm(ListVehicleInitialValues);
        setRefreshData && setRefreshData((prev) => prev + 1);
        modalContext?.setShowModal(false);
      },
    );
  };

  return (
    <ModalContainer label='List Vehicles'>
      <FormComponent
        initialValues={ListVehicleInitialValues}
        schema={ListVehicleSchema}
        onSubmit={onSubmit}
      >
        <CustomSelectField
          name='vehicleCategory'
          id='vehicleCategory'
          label='Vehicle Category'
          placeholder='Select a vehicle category'
          optionData={Object.keys(fleetCategories)}
        />

        <TextInputField
          type='text'
          name='plateNumber'
          id='plateNumber'
          label='License Plate Number'
          placeholder='e.g ACB-1234'
        />
        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            btnType='button'
            onClick={() => modalContext?.setShowModal(false)}
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton loading={loading} className='fill'>
            Add Vehicle
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

export default ListVehicleModal;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  /* margin-left: auto; */
`;
